import { Component, OnInit, ElementRef, ViewChildren, QueryList, ViewChild, ChangeDetectorRef, AfterContentChecked } from "@angular/core";
import { LazyLoadEvent,  MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { OverlayPanel } from "primeng/overlaypanel";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { City } from "src/classes/Common/City";
import { SetValid } from "src/classes/Common/SetValid";
import { CustomCategory, Customer, CustomerLazyOut, CustomerLazySearch } from "src/classes/Customers/Customer";
import { Occupation } from "src/classes/Customers/Occupation";
import { Recommender } from "src/classes/Customers/Recommender";
import { SourceArrival } from "src/classes/Customers/SourceArrival";
import { Proposal } from "src/classes/Customers/Proposal";
import { Menu } from "primeng/menu";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CardColor, ServiceCardColor, IconService } from "src/classes/Customers/CardColor";
import { CommonFunctions } from "src/app/helper/CommonFunctions";
import { Control } from "src/classes/Authorization/BusinessRole";
import { HttpServiceAccount } from "src/app/services/Authorization/http/http.service_Account";
import { screenId } from "src/environments/environment";
import { Carousel } from "primeng/carousel";
import { NGXLogger } from "ngx-logger";
import { NgModel } from "@angular/forms";
import { from, Subscription } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { Table } from "primeng/table";

type NewFileType = File & { isFileUploaded?: "uploading" | "uploaded" | "sizeError" | "uploadError" };

@Component({
    selector: "app-dynamicedit-screen",
    templateUrl: "./dynamicedit-screen.component.html",
    styleUrls: ["./dynamicedit-screen.component.css"],
    providers: [HttpServiceCustomer, MessageService, CommonFunctions, HttpServiceAccount]
})
export class DynamiceditScreenComponent implements OnInit, AfterContentChecked {
    controls: Control[];
    receivedObject: any;
    receivedvalid: SetValid = new SetValid();

    cities: City[];
    cityFilterValue: string = "";
    selectedCity: City;
    clonedCities: { [cityId: string]: City; } = {};

    categories: CustomCategory[];
    selectedCategories: CustomCategory[] = [];
    clonedCategories: { [categoryId: string]: CustomCategory; } = {};

    recommenders: Recommender[] = [];
    recommendersState: "loading" | "loaded" | "noresults" | "empty" | "pinned" = "empty";
    customerLazySearch: CustomerLazySearch = new CustomerLazySearch();
    recommendersSearchSubscription: Subscription;
    recommenderFilterValue: string = "";
    recommenderInput: string = "";
    selectedRecommender: Recommender;
    recommendersTotalRecords: number = 0;
    isRecommendersFirstLoad: boolean = true;
    @ViewChild("recommendersTable", { static: false }) recommendersTable: Table
    // recommendersSet: [{ recommenderId: number, recommenderName: string }];

    sources: SourceArrival[];
    sourceFilterValue: string = "";
    selectedSource: SourceArrival;
    clonedSources: { [sourceId: string]: SourceArrival; } = {};

    occupations: Occupation[];
    occupationFilterValue: string = "";
    selectedOccupation: Occupation;
    clonedOccupation: { [occupationId: string]: Occupation; } = {};

    isAddingNewElement: boolean = false;
    newElementValue: string = "";

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    proposal: Proposal;
    proposalComment: string;
    proposalURL: string;
    isProposalCommentCollapsed: boolean = true;
    proposalMenu: ExtendedMenuItem[];
    openedMenu: Menu;
    isProposalConfirmDialogVisible: boolean = false;
    isProposalMenuOpened: boolean = false;
    @ViewChild("proposalTextarea", { static: false }) proposalTextarea: ElementRef<HTMLTextAreaElement>;

    newFiles: NewFileType[];
    presignedURLdata: { businessId: string, clientId: string };

    chemistryServices: ServiceCardColor[];
    chemistryServicesIcons: IconService[];
    defaultChemistryServiceIcon: IconService;
    chemistryCarouselLength: number;
    responsiveChemistryCarousel: Object[];
    isAddingOrEditingChemistryService: boolean = false;
    selectedChemistryService: ServiceCardColor;
    chemistryServiceName: string = "";
    chemistryServiceIcon: IconService;
    cardColor: CardColor;
    maxDate: Date = new Date();
    chemistryServicesCarouselLength: number;
    responsiveServicesChemistryCarousel: Object[];
    chemistryCarouselPage: number;
    isChemistryServiceErrorVisible: boolean = false;
    isChemistryDateErrorVisible: boolean = false;
    @ViewChild("regDateModel", { static: false }) regDateModel: NgModel;

    isFooterVisible: boolean = true;
    isSubmitDisabled: boolean = false;
    isFooterClearVisible: boolean = true;

    @ViewChildren("row") rows: QueryList<ElementRef>;
    @ViewChild("addNewCityInput", { static: false }) addNewCityInput: ElementRef<HTMLInputElement>;
    @ViewChild("addNewCategoryInput", { static: false }) addNewCategoryInput: ElementRef<HTMLInputElement>;
    @ViewChild("addNewSourceInput", { static: false }) addNewSourceInput: ElementRef<HTMLInputElement>;
    @ViewChild("addNewOccupationInput", { static: false }) addNewOccupationInput: ElementRef<HTMLInputElement>;
    @ViewChild("chemistryServiceInput", { static: false }) chemistryServiceInput: ElementRef<HTMLInputElement>;
    @ViewChild("overlayPanelDeleteCity", { static: false }) overlayPanelDeleteCity: OverlayPanel;
    @ViewChild("chemistryCarouselError", { static: false }) chemistryCarouselError: ElementRef;

    constructor(
        private dynamicDialogService: DynamicDialogService,
        private httpClient: HttpClient,
        private messageService: MessageService,
        private httpServiceCustomer: HttpServiceCustomer,
        private changeDetector: ChangeDetectorRef,
        private commonFunctions: CommonFunctions,
        private httpServiceAccount: HttpServiceAccount,
        private logger: NGXLogger
    ) {
        Carousel.prototype.changePageOnTouch = (e, diff) => { }
    }

    ngOnInit() {
        this.receivedObject = this.dynamicDialogService.getConfigData();
        console.log("input_id: " + this.receivedObject.input_id);

        // Get the list of control states
        this.httpServiceAccount.getControlsByScreen({ screen_id: screenId.Customers.custcardview })
            .subscribe((res: [Control]) => {
                console.log(res);
                this.controls = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });


        if (this.receivedObject.input_id === 1) {
            this.httpServiceCustomer.getCities()
                .subscribe((data: City[]) => {
                    data = data.filter((city: City) => city.cityId !== 0);
                    this.cities = [...data];

                    console.log("Count of cities: " + this.cities.length);

                    if (this.receivedObject.value) {
                        this.selectedCity = this.cities.find(x => x.cityId === this.receivedObject.value);
                    }

                    console.log("CityId: " + this.receivedObject.value);

                    setTimeout(() => {
                        this.scrollToSelectedIndex();
                    }, 0);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
        else if (this.receivedObject.input_id === 2) {
            this.httpServiceCustomer.getCustomCategories()
                .subscribe((data: CustomCategory[]) => {
                    data = data.filter((category: CustomCategory) => category.custCategoryId !== 0).sort((a, b) => a.orderId - b.orderId);
                    this.categories = [...data];

                    console.log("Count of cities: " + this.categories.length);

                    if (this.receivedObject.value) {
                        this.selectedCategories = [...this.receivedObject.value];
                    }
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
        else if (this.receivedObject.input_id === 3) {
            // this.recommendersSet = JSON.parse(sessionStorage.getItem("recommendersSet"));

            // this.recommenders = Object.keys(this.recommendersSet).map((recommender) => ({ recommenderId: parseInt(recommender), recommenderName: this.recommendersSet[recommender] })).filter(x => x.recommenderName != null);

            if (this.receivedObject.value.id != 0) {
                this.selectedRecommender = { recommenderId: this.receivedObject.value.id, recommenderName: this.receivedObject.value.name }
                this.recommendersState = "pinned";
                this.recommenders = [this.selectedRecommender];
                this.recommendersTotalRecords = 1;
            }
            else {
                this.selectedRecommender = { recommenderId: 0, recommenderName: "בחר" };
                this.recommendersState = "empty";
            }

            // if (this.receivedObject.value && this.receivedObject.value.id != 0) {
            //     this.selectedRecommender = this.recommenders.find(x => x.recommenderId == this.receivedObject.value.id);
            // }
            // else {
            //     this.selectedRecommender = { recommenderId: 0, recommenderName: "בחר" };
            // }
        }
        else if (this.receivedObject.input_id === 4) {
            this.httpServiceCustomer.getSourcesArrival()
                .subscribe((data: SourceArrival[]) => {
                    data = data.sort((a, b) => a.orderId - b.orderId);
                    this.sources = data;

                    console.log("Count of cities: " + this.sources.length);

                    if (this.receivedObject.value) {
                        this.selectedSource = this.sources.find(x => x.sourceId === this.receivedObject.value);
                    }

                    console.log("SourceId: " + this.receivedObject.value);

                    setTimeout(() => {
                        this.scrollToSelectedIndex();
                    }, 0);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
        else if (this.receivedObject.input_id === 5) {
            this.httpServiceCustomer.getOccupation()
                .subscribe((data: Occupation[]) => {
                    console.log(data);
                    this.occupations = data;

                    if (this.receivedObject.value) {
                        this.selectedOccupation = this.occupations.find(x => x.occupationId === this.receivedObject.value);
                    }

                    setTimeout(() => {
                        this.scrollToSelectedIndex();
                    }, 0);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                })
        }
        else if (this.receivedObject.input_id === 6) {
            this.proposal = this.receivedObject.value.proposal;
            this.proposalComment = this.proposal.comments;
            this.proposalURL = this.receivedObject.value.proposalURL;
            this.proposalMenu = this.receivedObject.value.proposalMenu;
            this.proposalMenu.find((item: ExtendedMenuItem) => item.label == "מחיקה").command = () => {
                this.isProposalConfirmDialogVisible = true;
                this.isProposalMenuOpened = false;
            };
            this.isFooterVisible = false;
            this.isFooterClearVisible = false;
            // setTimeout(() => {
            //     this.proposalTextarea.nativeElement.focus();
            // }, 0);
        }
        else if (this.receivedObject.input_id === 7) {
            this.newFiles = this.receivedObject.value.newFiles;
            this.presignedURLdata = this.receivedObject.value.presignedURLdata;
            this.isFooterVisible = false;
            this.isFooterClearVisible = false;

            this.uploadProposals();
        }
        else if (this.receivedObject.input_id === 8) {
            this.chemistryServices = this.receivedObject.value.services.sort((a: ServiceCardColor, b: ServiceCardColor) => a.orderId - b.orderId);
            this.chemistryServicesIcons = this.receivedObject.value.icons.slice();
            this.defaultChemistryServiceIcon = this.chemistryServicesIcons.shift();
            this.chemistryCarouselLength = Math.min(this.chemistryServicesIcons.length, 6);
            this.responsiveChemistryCarousel = [{
                breakpoint: "412px",
                numVisible: Math.min(this.chemistryServicesIcons.length, 4),
                numScroll: 1
            }];
            this.isFooterClearVisible = false;
        }
        else if (this.receivedObject.input_id === 9) {
            this.chemistryServices = this.receivedObject.value.services.sort((a: ServiceCardColor, b: ServiceCardColor) => a.orderId - b.orderId);
            this.chemistryServicesCarouselLength = Math.min(this.chemistryServices.length, 5);
            this.responsiveServicesChemistryCarousel = [{
                breakpoint: "767px",
                numVisible: Math.min(this.chemistryServices.length, 7),
                numScroll: 1
            },
            {
                breakpoint: "640px",
                numVisible: Math.min(this.chemistryServices.length, 6),
                numScroll: 1
            },
            {
                breakpoint: "575px",
                numVisible: Math.min(this.chemistryServices.length, 5),
                numScroll: 1
            },
            {
                breakpoint: "412px",
                numVisible: Math.min(this.chemistryServices.length, 4),
                numScroll: 1
            }];
            this.cardColor = Object.assign({}, this.receivedObject.value.cardColor);
            this.selectedChemistryService = this.chemistryServices.find((service: ServiceCardColor) => service.serviceInd == this.cardColor.serviceInd);
            this.chemistryCarouselPage = Math.max(0, this.chemistryServices.indexOf(this.selectedChemistryService) - 2);
            this.isFooterClearVisible = false;
        }
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

    getCitiesValue(): City[] {
        if (this.cities) {
            return this.cities.filter((city: City) => city.cityName.toLowerCase().includes(this.cityFilterValue.toLowerCase()));
        }
    }

    isCitiesEmpty(): boolean {
        if (this.cities && !this.cities.length) {
            return true;
        }
        return false;
    }

    isCitiesNoResults(): boolean {
        if (this.cities && !this.cities.filter((city: City) => city.cityName.toLowerCase().includes(this.cityFilterValue.toLowerCase())).length) {
            return true;
        }
        return false;
    }

    getSourcesValue(): SourceArrival[] {
        if (this.sources) {
            return this.sources.filter((source: SourceArrival) => source.sourceName.toLowerCase().includes(this.sourceFilterValue.toLowerCase()));
        }
    }

    getOccupationsValue(): Occupation[] {
        if (this.occupations) {
            return this.occupations.filter((occupations: Occupation) => occupations.occupationName.toLowerCase().includes(this.occupationFilterValue.toLowerCase()));
        }
    }

    toggleAddingNewElement(): void {
        this.isAddingNewElement = !this.isAddingNewElement;
        if (this.isAddingNewElement) {
            this.newElementValue = "";
            if (this.receivedObject.input_id === 1) {
                setTimeout(() => {
                    this.addNewCityInput.nativeElement.focus();
                }, 0);
            }
            else if (this.receivedObject.input_id === 2) {
                setTimeout(() => {
                    this.addNewCategoryInput.nativeElement.focus();
                }, 0);
            }
            else if (this.receivedObject.input_id === 4) {
                setTimeout(() => {
                    this.addNewSourceInput.nativeElement.focus();
                }, 0);
            }
            else if (this.receivedObject.input_id === 5) {
                setTimeout(() => {
                    this.addNewOccupationInput.nativeElement.focus();
                }, 0);
            }
        }
    }

    saveNewElement(): void {
        if (this.receivedObject.input_id === 1) {
            if (this.newElementValue) {
                const maxId: number = this.cities.length ? this.cities.reduce((accumulator, current) => {
                    return accumulator.cityId > current.cityId ? accumulator : current;
                }).cityId + 1 : 1;
                this.cities.unshift({ cityId: maxId, cityName: this.newElementValue });
            }
        }
        else if (this.receivedObject.input_id === 2) {
            if (this.newElementValue) {
                const maxId: number = this.categories.length ? this.categories.reduce((accumulator, current) => {
                    return accumulator.custCategoryId > current.custCategoryId ? accumulator : current;
                }).custCategoryId + 1 : 1;
                this.categories.unshift({ custCategoryId: maxId, custCategoryName: this.newElementValue });
            }
        }
        else if (this.receivedObject.input_id === 4) {
            if (this.newElementValue) {
                const maxId: number = this.sources.length ? this.sources.reduce((accumulator, current) => {
                    return accumulator.sourceId > current.sourceId ? accumulator : current;
                }).sourceId + 1 : 1;
                this.sources.unshift({ sourceId: maxId, sourceName: this.newElementValue });
            }
        }
        else if (this.receivedObject.input_id === 5) {
            if (this.newElementValue) {
                const maxId: number = this.occupations.length ? this.occupations.reduce((accumulator, current) => {
                    return accumulator.occupationId > current.occupationId ? accumulator : current;
                }).occupationId + 1 : 1;
                this.occupations.unshift({ occupationId: maxId, occupationName: this.newElementValue });
            }
        }

        this.toggleAddingNewElement();
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    onRowEditInit(element: any, row: HTMLElement) {
        if (this.receivedObject.input_id === 1) {
            this.clonedCities[element.cityId] = { ...element };
        }
        else if (this.receivedObject.input_id === 2) {
            this.clonedCategories[element.custCategoryId] = { ...element };
        }
        else if (this.receivedObject.input_id === 4) {
            this.clonedSources[element.sourceId] = { ...element };
        }
        else if (this.receivedObject.input_id === 5) {
            this.clonedOccupation[element.occupationId] = { ...element };
        }

        setTimeout(() => {
            (row.querySelector(".column-editable__input") as HTMLInputElement).focus();
        }, 0);
    }

    onRowEditSave(element: any) {
        if (this.receivedObject.input_id === 1) {
            if (element.cityId > 0) {
                delete this.clonedCities[element.cityId];
                this.showMessage("success", "שם העיר מעודכן");
            }
            else {
                this.showMessage("error", "שם העיר שדה חובה");
            }
        }
        else if (this.receivedObject.input_id === 2) {
            if (element.custCategoryId > 0) {
                delete this.clonedCategories[element.custCategoryId];

                let changedSelectedCategoryIndex = this.selectedCategories.findIndex((category: CustomCategory) => category.custCategoryId == element.custCategoryId);
                this.selectedCategories[changedSelectedCategoryIndex].custCategoryName = element.custCategoryName;

                this.showMessage("success", "שם העיר מעודכן");
            }
            else {
                this.showMessage("error", "שם העיר שדה חובה");
            }
        }
        else if (this.receivedObject.input_id === 4) {
            if (element.sourceId > 0) {
                delete this.clonedSources[element.sourceId];
                this.showMessage("success", "שם העיר מעודכן");
            }
            else {
                this.showMessage("error", "שם העיר שדה חובה");
            }
        }
        else if (this.receivedObject.input_id === 5) {
            if (element.occupationId > 0) {
                delete this.clonedOccupation[element.occupationId];
                this.showMessage("success", "שם העיר מעודכן");
            }
            else {
                this.showMessage("error", "שם העיר שדה חובה");
            }
        }
    }

    onRowEditCancel(element: any, index: number) {
        if (this.receivedObject.input_id === 1) {
            this.cities[index] = this.clonedCities[element.cityId];
            delete this.clonedCities[element.cityId];
        }
        else if (this.receivedObject.input_id === 2) {
            this.categories[index] = this.clonedCategories[element.custCategoryId];
            delete this.clonedCategories[element.custCategoryId];
        }
        else if (this.receivedObject.input_id === 4) {
            this.sources[index] = this.clonedSources[element.sourceId];
            delete this.clonedSources[element.sourceId];
        }
        else if (this.receivedObject.input_id === 5) {
            this.occupations[index] = this.clonedOccupation[element.occupationId];
            delete this.clonedOccupation[element.occupationId];
        }
    }

    removeElement(element: any): void {
        if (this.receivedObject.input_id === 1) {
            if (!element.isUsed) {
                this.cities.splice(this.cities.indexOf(element), 1);
                this.messageService.clear();
                if (this.selectedCity && this.selectedCity.cityId == element.cityId) {
                    this.selectedCity = undefined;
                }
            }
            else {
                this.showMessage("error", "לא ניתן למחוק. נמצא בשימוש.");
            }
        }
        else if (this.receivedObject.input_id === 2) {
            if (!element.isUsed) {
                this.categories.splice(this.categories.indexOf(element), 1);
                this.selectedCategories.splice(this.selectedCategories.indexOf(element), 1);
                this.messageService.clear();
            }
            else {
                this.showMessage("error", "לא ניתן למחוק. נמצא בשימוש.");
            }
        }
        else if (this.receivedObject.input_id === 4) {
            if (!element.isUsed) {
                this.sources.splice(this.sources.indexOf(element), 1);
                this.messageService.clear();
                if (this.selectedSource && this.selectedSource.orderId == element.orderId) {
                    this.selectedSource = undefined;
                }
            }
            else {
                this.showMessage("error", "לא ניתן למחוק. נמצא בשימוש.");
            }
        }
        else if (this.receivedObject.input_id === 5) {
            if (!element.isUsed) {
                this.occupations.splice(this.occupations.indexOf(element), 1);
                this.messageService.clear();
                if (this.selectedOccupation && this.selectedOccupation.occupationId == element.occupationId) {
                    this.selectedOccupation = undefined;
                }
            }
            else {
                this.showMessage("error", "לא ניתן למחוק. נמצא בשימוש.");
            }
        }
        else if (this.receivedObject.input_id === 8) {
            if (!element.isUsed) {
                this.chemistryServices.splice(this.chemistryServices.indexOf(element), 1);
                this.messageService.clear();
            }
            else {
                this.showMessage("error", "לא ניתן למחוק. נמצא בשימוש.");
            }
        }

    }

    onSourceRowReorder(event: { dragIndex: number, dropIndex: number }): void {
        [this.sources[event.dragIndex], this.sources[event.dropIndex]] = [this.sources[event.dropIndex], this.sources[event.dragIndex]];
    }

    clearSelected(): void {
        if (this.receivedObject.input_id === 1) {
            this.selectedCity = undefined;
        }
        else if (this.receivedObject.input_id === 2) {
            this.selectedCategories = [];
        }
        else if (this.receivedObject.input_id === 3) {
            if (this.selectedRecommender.recommenderId) {
                this.selectedRecommender = { recommenderId: 0, recommenderName: "בחר" };

                if (this.recommendersState == "pinned") {
                    this.recommendersState = "empty";
                }
            }
        }
        else if (this.receivedObject.input_id === 4) {
            this.selectedSource = undefined;
        }
        else if (this.receivedObject.input_id === 5) {
            this.selectedOccupation = undefined;
        }
    }

    onRecommendersPageChange(): void {
        this.recommendersState = "loading";
    }

    searchRecommender(): void {
        this.recommenderFilterValue = this.recommenderInput;

        if (this.recommenderFilterValue.length >= 2) {
            this.lazyLoadRecommenders();
        }
        else {
            if (this.selectedRecommender.recommenderId) {
                this.recommendersState = "pinned"
                this.recommenders = [this.selectedRecommender];
                this.recommendersTotalRecords = 1;
            }
            else {
                this.recommendersState = "empty";
            }
        }
    }

    lazyLoadRecommenders(event?: LazyLoadEvent): void {
        if (this.isRecommendersFirstLoad) {
            this.isRecommendersFirstLoad = false;
            return;
        }

        if (event) {
            this.customerLazySearch.page = event.first / event.rows;
            this.customerLazySearch.size = event.rows;
        }
        else {
            this.customerLazySearch.page = 0;
            this.customerLazySearch.size = 50;
        }

        this.customerLazySearch.classification = 0;
        this.customerLazySearch.category = 0;
        this.customerLazySearch.sex = 0;
        this.customerLazySearch.sortOrder = 1;
        this.customerLazySearch.search = this.recommenderFilterValue.toLowerCase();

        this.recommendersState = "loading";

        if (this.recommendersSearchSubscription && !this.recommendersSearchSubscription.closed) {
            this.recommendersSearchSubscription.unsubscribe();
        }

        this.recommendersSearchSubscription = this.httpServiceCustomer.getCustomersLazySearch(this.customerLazySearch)
            .subscribe((response: CustomerLazyOut) => {
                this.recommenders = [...response.items.map((item: Customer) => ({ recommenderId: item.customerId, recommenderName: item.fl }))];

                this.recommendersTotalRecords = response.totalCount;

                if (!response.totalCount) {
                    this.recommendersState = "noresults";
                }
                else {
                    this.recommendersState = "loaded";
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    toggleSubMenu(event: PointerEvent, menu: Menu, isMobile: boolean): void {
        if (isMobile) {
            this.isProposalMenuOpened = true;
        }
        else {
            menu.toggle(event);

            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    closeProposalConfirmDialog(isAccepted: boolean): void {
        if (isAccepted) {
            this.receivedObject.value = this.proposal;
            this.dynamicDialogService.closeDialog(this.receivedObject);
        }

        this.isProposalConfirmDialogVisible = false;
    }

    toggleAddignNewChemistryService(): void {
        this.isAddingOrEditingChemistryService = !this.isAddingOrEditingChemistryService;
        this.isSubmitDisabled = !this.isSubmitDisabled;
        if (this.isAddingOrEditingChemistryService) {
            this.selectedChemistryService = null;
            this.chemistryServiceName = "";
            this.chemistryServiceIcon = null;

            setTimeout(() => {
                this.chemistryServiceInput.nativeElement.focus();
            }, 0);
        }
    }

    editChemistryService(service: ServiceCardColor): void {
        this.selectedChemistryService = service;
        this.chemistryServiceName = service.serviceName;
        this.chemistryServiceIcon = this.chemistryServicesIcons.find((icon: IconService) => icon.serviceIconId === service.serviceIconId);
        this.isAddingOrEditingChemistryService = true;
        this.isSubmitDisabled = true;

        setTimeout(() => {
            this.chemistryServiceInput.nativeElement.focus();
        }, 0);
    }

    selectChemistryIcon(icon: IconService): void {
        if (this.chemistryServiceIcon == icon) {
            this.chemistryServiceIcon = null;
        }
        else {
            this.chemistryServiceIcon = icon;
        }
    }

    saveChemistryService(): void {
        if (!this.chemistryServiceIcon) {
            this.chemistryServiceIcon = this.defaultChemistryServiceIcon;
        }

        if (this.selectedChemistryService) {
            this.selectedChemistryService.serviceIconId = this.chemistryServiceIcon.serviceIconId;
            this.selectedChemistryService.serviceIconName = this.chemistryServiceIcon.serviceIconName;
            this.selectedChemistryService.serviceName = this.chemistryServiceName;
        }
        else {
            const maxId: number = this.chemistryServices.length ? this.chemistryServices.reduce((accumulator, current) => {
                return accumulator.serviceInd > current.serviceInd ? accumulator : current;
            }).serviceInd + 1 : 1;

            this.chemistryServices.unshift({
                serviceInd: maxId,
                serviceName: this.chemistryServiceName,
                serviceIconId: this.chemistryServiceIcon.serviceIconId,
                serviceIconName: this.chemistryServiceIcon.serviceIconName,
                isUsed: false,
                orderId: 0
            });
        }

        this.showMessage("success", "כימיה חדשה התווסף בהצלחה");

        this.selectedChemistryService = null;
        this.chemistryServiceName = "";
        this.chemistryServiceIcon = null;
        this.isAddingOrEditingChemistryService = false;
        this.isSubmitDisabled = false;
    }

    selectChemistryService(service: ServiceCardColor): void {
        if (this.selectedChemistryService == service) {
            this.selectedChemistryService = null;
        }
        else {
            this.selectedChemistryService = service;
        }
    }

    isCloseProposalUploadingPopupDisabled(): boolean {
        return this.newFiles.some((file: NewFileType) => file.isFileUploaded == "uploading");
    }

    uploadProposals(): void {
        from(this.newFiles).pipe(
            mergeMap((file: NewFileType) => {
                if (file.size <= 15 * 1024 * 1024) {
                    return from(
                        this.uploadProposalToAWS(file).then(() => {
                            this.showMessage("success", `קובץ ${file.name} עלה בהצלחה`);
                            file.isFileUploaded = "uploaded";
                        }).catch((error) => {
                            console.log(error);
                            this.showMessage("error", `קובץ ${file.name} נכשל בהעלאה`);
                            file.isFileUploaded = "uploadError";
                        })
                    );
                } else {
                    this.showMessage("error", `קובץ ${file.name} נכשל בהעלאה (חורג ממגבלות גודל 15 לקובץ)`);
                    file.isFileUploaded = "sizeError";
                    return from(Promise.resolve());
                }
            }, 10) // maximum parallel uploadings (10 max)
        ).subscribe();
    }

    async uploadProposalToAWS(file: File): Promise<any> {
        const response: any = await this.httpClient.post(
            "https://12x2ym9xp9.execute-api.eu-north-1.amazonaws.com/v2/presign",
            {
                ...this.presignedURLdata,
                fileName: file.name,
                contentType: file.type
            }, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        }).toPromise();

        const presignedURL: string = JSON.parse(response.body).url;

        return this.httpClient.put(presignedURL, file, {
            headers: new HttpHeaders({ "Content-Type": file.type })
        }).toPromise();
    }

    saveData(): void {
        if (this.receivedObject.input_id === 1) {
            if (this.selectedCity != undefined) {
                this.receivedObject.value = this.selectedCity.cityId;
                this.receivedObject.option = this.selectedCity.cityName;
            }

            this.saveDataCities();
        }
        else if (this.receivedObject.input_id === 2) {
            this.receivedObject.value = this.selectedCategories;

            this.saveCustomCategoies();
        }
        else if (this.receivedObject.input_id === 3) {
            if (this.selectedRecommender) {
                this.receivedObject.value.name = this.selectedRecommender.recommenderName;
                this.receivedObject.value.id = this.selectedRecommender.recommenderId;
            }
            else {
                this.receivedObject.value.name = "בחר";
                this.receivedObject.value.id = 0;
            }
        }
        else if (this.receivedObject.input_id === 4) {
            if (this.selectedSource != undefined) {
                this.receivedObject.value = this.selectedSource.sourceId;
                this.receivedObject.option = this.selectedSource.sourceName;
            }

            this.saveDataSources();
        }
        else if (this.receivedObject.input_id === 5) {
            if (this.selectedOccupation != undefined) {
                this.receivedObject.value = this.selectedOccupation.occupationId;
                this.receivedObject.option = this.selectedOccupation.occupationName;
            }

            this.saveDataOccupations();
        }
        else if (this.receivedObject.input_id === 6) {
            this.receivedObject.value = this.proposalComment;
        }
        else if (this.receivedObject.input_id === 8) {
            this.receivedObject.value = this.chemistryServices;

            this.saveDataChemistryServices();
        }
        else if (this.receivedObject.input_id === 9) {
            this.isChemistryServiceErrorVisible = false;
            this.isChemistryDateErrorVisible = false;

            if (!this.selectedChemistryService) {
                this.isChemistryServiceErrorVisible = true;
                
                // ability to scroll to the carousel error in case users don't understand why chemistry isn't being saved
                // this.chemistryCarouselError.nativeElement.scrollIntoView({ behavior: "smooth" });
            }

            if (this.regDateModel.invalid || this.cardColor.regDate == "") {
                this.isChemistryDateErrorVisible = true;
            }

            if (this.isChemistryServiceErrorVisible || this.isChemistryDateErrorVisible) {
                return;
            }

            if (typeof (this.cardColor.regDate) == "object") {
                this.cardColor.regDate = this.commonFunctions.dateToString(new Date(this.cardColor.regDate));
            }
            this.cardColor.serviceInd = this.selectedChemistryService.serviceInd;
            this.cardColor.serviceName = this.selectedChemistryService.serviceName;
            this.cardColor.serviceIconId = this.selectedChemistryService.serviceIconId;
            this.cardColor.iconName = this.selectedChemistryService.serviceIconName;

            this.receivedObject.value = this.cardColor;
        }

        this.dynamicDialogService.closeDialog(this.receivedObject);
    }

    closeModal(): void {
        this.dynamicDialogService.closeDialog();
    }

    saveDataCities(): void {
        this.httpServiceCustomer.setCities(this.cities)
            .then((res: SetValid) => {
                this.receivedvalid = res;
                console.log("Cities data saved: " + this.receivedvalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    saveCustomCategoies(): void {
        for (let i = 0; i < this.categories.length; i++) {
            this.categories[i].orderId = i + 1;
        }

        this.httpServiceCustomer.setCustomCategories(this.categories)
            .then((res: SetValid) => {
                this.receivedvalid = res;
                console.log("Custom сategoies saved: " + this.receivedvalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    saveDataSources(): void {
        for (let i = 0; i < this.sources.length; i++) {
            this.sources[i].orderId = i + 1;
        }

        this.httpServiceCustomer.setSourcesArrival(this.sources)
            .then((res: SetValid) => {
                this.receivedvalid = res;
                console.log("Sources data saved: " + this.receivedvalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    saveDataOccupations(): void {
        this.httpServiceCustomer.setOccupation(this.occupations)
            .then((res: SetValid) => {
                this.receivedvalid = res;
                console.log("Occupations data saved: " + this.receivedvalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    saveDataChemistryServices(): void {
        for (let i = 0; i < this.chemistryServices.length; i++) {
            this.chemistryServices[i].orderId = i + 1;
        }

        this.httpServiceCustomer.setServicesCardColor(this.chemistryServices)
            .then((res: SetValid) => {
                this.receivedvalid = res;
                console.log("Services cardcolor data saved: " + this.receivedvalid.answer);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    scrollToSelectedIndex(): void {
        let selectedRowIndex: number;
        if (this.receivedObject.input_id === 1) {
            selectedRowIndex = this.cities.indexOf(this.selectedCity) - 2;
        }
        else if (this.receivedObject.input_id === 4) {
            selectedRowIndex = this.sources.indexOf(this.selectedSource) - 2;
        }
        else if (this.receivedObject.input_id === 5) {
            selectedRowIndex = this.occupations.indexOf(this.selectedOccupation) - 2;
        }

        if (selectedRowIndex > 0) {
            this.rows.toArray()[selectedRowIndex].nativeElement.scrollIntoView({ behavior: "instant" });
        }
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controls) {
            let control = this.controls.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }
}
